export default {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            const path = event.composedPath ? event.composedPath() : event.path;
            if (path && !path.includes(el)) {
                vnode.context[binding.expression](event);
            }
        };
        document.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.removeEventListener('click', el.clickOutsideEvent);
    },
};
